<div class="left-modal">
  <div class="close" (click)="close()"></div>
  @if (loading) {
    <div class="loader"></div>
  }
  @if (!loading) {
    <div class="modal-container">
      @if (!catering) {
        <h1>{{'Add catering' | translate}}</h1>
      }
      @if (catering) {
        <h1>{{'Edit catering' | translate}}</h1>
      }
      @if (error) {
        <div class="errorMessage">{{ error | translate}}</div>
      }
      <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
        <div class="columns" [ngClass]="{'L-8 M-8 S-8': hasShooting, 'L-4 M-4 S-4': !hasShooting}">
          <label>{{'Type' | translate}}**</label>
          <app-dropdown
            [(appModel)]="formData.catering_type_id"
            [list]="types"
            [value]="'id'"
            [name]="'catering_name'"
            [backTranslate]="true"
          ></app-dropdown>
        </div>
        @if (!hasShooting) {
          <div class="L-4 M-4 S-4 columns">
            <label>{{'Date' | translate}}**</label>
            <input type="date" name="date" [(ngModel)]="formData.date" required>
          </div>
        }
        @if (!hasShooting) {
          <div class="L-4 M-4 S-4 columns">
            <label>{{'Unit' | translate}}</label>
            <app-dropdown
              [(appModel)]="formData.unit_id"
              [list]="lists.units"
              [value]="'id'"
              [name]="'unit_name'"
              [multiple]="false"
            ></app-dropdown>
          </div>
        }
        <div class="L-4 M-4 S-4 columns">
          <label>{{'Time' | translate}}**</label>
          <input class="centered" type="time" name="time" [(ngModel)]="formData.time" required>
        </div>
        <div class="L-4 M-4 S-4 columns">
          <label>{{'Quantity' | translate}}**</label>
          <input class="centered" type="text" name="quantity" [(ngModel)]="formData.quantity" required>
        </div>
        @if (showFields()) {
          <div class="L-4 M-4 S-4 columns">
            <label>{{'Unit cost' | translate}}**</label>
            <input currencyMask type="text" name="cost_unit" [(ngModel)]="formData.cost_unit">
          </div>
        }
        <!-- <div class="L-8 M-8 S-8 columns">
        <label>{{'Vendor' | translate}}</label>
        <input class="centered" type="text" name="vendor" [(ngModel)]="formData.vendor">
      </div> -->
      <!-- <div class="L-8 M-8 S-8 columns">
      <label>{{'Location' | translate}}</label>
      <input class="centered" type="text" name="location" [(ngModel)]="formData.location">
    </div> -->
    <div class="L-12 M-12 S-12 columns TextCentered">
      <input name="sumbit" type="submit" value="{{'Save' | translate}}"  [disabled]="form.invalid">
    </div>
    <div class="L-12 M-12 S-12 columns TextCentered">
      <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
    </div>
  </form>
</div>
}
</div>